import { Check } from "lucide-react";
import {
  LEAD_ASSIGNABLE_ROLES,
  type AssignmentActions,
  type LeadAssignmentMember,
} from "@school-sales-ai/shared";
import {
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

/**
 * The entries of an «Asignado a» menu, for whatever `assignmentActionsFor`
 * granted. Shared by the lead page's `AssigneeControl` and the board card's
 * «Asignar a…» submenu, so the two can never offer different things.
 */
export function AssigneeMenuItems({
  actions,
  members,
  viewerId,
  assignedProfileId,
  onSelect,
}: {
  actions: AssignmentActions;
  members: LeadAssignmentMember[];
  viewerId: string;
  assignedProfileId: string | null;
  onSelect: (profileId: string | null) => void;
}): React.JSX.Element {
  const team = members.filter((m) => m.active && LEAD_ASSIGNABLE_ROLES.includes(m.role));

  return (
    <>
      {actions.canAssignAny ? (
        <>
          <DropdownMenuLabel>Asignar a</DropdownMenuLabel>
          <DropdownMenuItem onSelect={() => onSelect(null)}>
            <span className="flex w-full items-center justify-between gap-2">
              <span className="italic text-ink-500">Sin asignar</span>
              {assignedProfileId === null ? <Check size={14} /> : null}
            </span>
          </DropdownMenuItem>
          {team.map((m) => (
            <DropdownMenuItem key={m.id} onSelect={() => onSelect(m.id)}>
              <span className="flex w-full items-center justify-between gap-2">
                <span className="truncate">
                  {m.name}
                  {m.id === viewerId ? " (yo)" : ""}
                </span>
                {assignedProfileId === m.id ? <Check size={14} /> : null}
              </span>
            </DropdownMenuItem>
          ))}
        </>
      ) : null}

      {actions.canClaim ? (
        <DropdownMenuItem onSelect={() => onSelect(viewerId)}>Asignarme</DropdownMenuItem>
      ) : null}

      {actions.canTransfer ? (
        <>
          <DropdownMenuLabel>Transferir a</DropdownMenuLabel>
          {team
            .filter((m) => m.id !== viewerId)
            .map((m) => (
              <DropdownMenuItem key={m.id} onSelect={() => onSelect(m.id)}>
                {m.name}
              </DropdownMenuItem>
            ))}
        </>
      ) : null}

      {actions.canRelease ? (
        <>
          {actions.canTransfer ? <DropdownMenuSeparator /> : null}
          <DropdownMenuItem onSelect={() => onSelect(null)}>Liberar prospecto</DropdownMenuItem>
        </>
      ) : null}
    </>
  );
}
